import React from 'react'
import { object, string } from 'prop-types'

class NLParkingInformation extends React.Component {
  render () {
    const { productData = {}, id } = this.props
    if (!productData.name) return null
    const productPrice = productData.prices && productData.prices.per_week ? productData.prices.per_week : null

    return (
      <div id={id}>
        {productPrice && (
          <p>8 dagen parkeren vanaf <span className='priceSpan' style={{ color: '#800080', fontSize: '24px' }}>&euro; {productPrice}</span></p>
        )}

        {productData.sellingpoint && (
          <h2 dangerouslySetInnerHTML={{ __html: productData.sellingpoint }} />
        )}

        {productData.transfer && [
          <h2 key='nlProductInformation1Title'>Transfer:</h2>,
          <p key='nlProductInformation1Content' dangerouslySetInnerHTML={{ __html: productData.transfer }} />
        ]}

        {productData.transferdauer && [
          <h2 key='nlProductInformation2Title'>Transferduur:</h2>,
          <p key='nlProductInformation2Content' dangerouslySetInnerHTML={{ __html: productData.transferdauer }} />
        ]}

        {productData.sicherheit && [
          <h2 key='nlProductInformation3Title'>Veiligheid:</h2>,
          <p key='nlProductInformation3Content' dangerouslySetInnerHTML={{ __html: productData.sicherheit }} />
        ]}

        {productData.pkw_groesse && [
          <h2 key='nlProductInformation4Title'>Autoafmetingen:</h2>,
          <p key='nlProductInformation4Content' dangerouslySetInnerHTML={{ __html: productData.pkw_groesse }} />
        ]}

        {productData.kindersitz && [
          <h2 key='nlProductInformation5Title'>Bij aankomst:</h2>,
          <p key='nlProductInformation5Content' dangerouslySetInnerHTML={{ __html: productData.kindersitz }} />
        ]}

        {productData.bei_der_anreise_ && [
          <h2 key='nlProductInformation6Title'>Bij aankomst:</h2>,
          <p key='nlProductInformation6Content' dangerouslySetInnerHTML={{ __html: productData.bei_der_anreise_ }} />
        ]}

        {productData.bei_der_abreise && [
          <h2 key='nlProductInformation7Title'>Bij terugkomst:</h2>,
          <p key='nlProductInformation7Content' dangerouslySetInnerHTML={{ __html: productData.bei_der_abreise }} />
        ]}

        {productData.hinweis && [
          <h2 key='nlProductInformation8Title'>Alstublieft let op:</h2>,
          <p key='nlProductInformation8Content' dangerouslySetInnerHTML={{ __html: productData.hinweis }} />
        ]}

        {productData.adresse && [
          <h2 key='nlProductInformation9Title'>Adres:</h2>,
          <p key='nlProductInformation9Content' dangerouslySetInnerHTML={{ __html: productData.name }} />,
          <p key='nlProductInformation10Content' dangerouslySetInnerHTML={{ __html: productData.adresse }} />
        ]}

        {productData.parkplatzbetreibertipp && (
          <div id='toptipbox'>
            <span className='toptipimage' />
            <h2>Tips direct van de parkeerplaats:</h2>
            <p dangerouslySetInnerHTML={{ __html: productData.parkplatzbetreibertipp }} />
          </div>
        )}
        <a className='pull-right' href='#top'>naar boven <i className='fa fa-arrow-circle-up' /></a>
      </div>
    )
  }
}

NLParkingInformation.propTypes = {
  productData: object,
  id: string
}

NLParkingInformation.defaultProps = {
  productData: { }
}

export default NLParkingInformation



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/specificProduct/nl-productInformation.jsx